export const RatingCode = ({ props }) => ([{text: 'N.A.', value: '::null'}].concat(props.resultRatings.map(entry => ({
  text: entry.code,
  value: `:=${entry.code}`
}))))
